import React, { useContext, useState, useEffect, useRef, memo } from "react";
import Grid from "@mui/material/Grid";
import Typographym from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import MyCard from "../../../shared/components/MyCard";
import { Mycontext } from "../../mycontext";

const Pcards = memo(({ data, name, ismenu, types }) => {
  const [filter, setFilter] = useState("");
  const [first, setFirst] = useState(true);
  const [addmore, setAddmore] = useState(8);
  const { setIsFavoriteVisible } = useContext(Mycontext);
  const loader = useRef(null);

  useEffect(() => {
    const savedScrollPosition = localStorage.getItem("scrollPosition");
    const savedFilter = localStorage.getItem("filter");
    const savedAddMore = localStorage.getItem("addMore");
    if (savedFilter) setFilter(savedFilter);
    if (savedAddMore) setAddmore(parseInt(savedAddMore, 10));
    if (savedScrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }, 100);
    }
    if (first && types.length > 0) {
      setFilter(types[0]);
      setFirst(false);
    }
  }, [first, types]);

  const set_filter = (fil) => {
    if (fil !== undefined && fil !== "") {
      setFilter(fil);
      localStorage.setItem("filter", fil);
      setFirst(false);
    }
  };

  const moreproduct = () => {
    setAddmore((prevAddmore) => {
      const newAddMore = prevAddmore + 4;
      localStorage.setItem("addMore", newAddMore);
      return newAddMore;
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          moreproduct();
        }
      },
      { threshold: 1, rootMargin: "20%" }
    );

    if (loader.current) observer.observe(loader.current);

    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, [loader]);

  const get_cards = (dat) => (
    <>
      {dat.slice(0, addmore).map((el) => (
        <Grid
          item
          xs={6}
          sm={6}
          md={4}
          lg={3}
          width="100%"
          container
          key={el.id}
          display="flex"
          justifyContent="center"
        >
          <MyCard el={el} /> {/* MyCard'ı burada çağırıyoruz */}
        </Grid>
      ))}
      <Grid
        item
        sm={12}
        md={12}
        lg={12}
        width="100%"
        justifyContent="center"
        display={dat.length > addmore ? "block" : "none"}
        ref={loader}
      >
        <Button
          color="error"
          variant="contained"
          width="40%"
          sx={{ ml: { xs: "35%", sm: "35%", md: "45%" } }}
          onClick={moreproduct}
        >
          Lisää Tuotteet
        </Button>
      </Grid>
    </>
  );

  return (
    <Box flexGrow={1} width={{ lg: "80%", md: "90%", sm: "100%" }} ml={{ md: "5%", lg: "10%" }} mt="3vh">
      <Box width="100%" mb="4vh" display={ismenu ? "block" : "none"}>
        <Typographym color="error" variant="h4">
          {name}
        </Typographym>
      </Box>
      <Grid container spacing={2} justifyContent="center" columns={{ sm: 12, md: 12, lg: 12 }}>
        <Grid item sm={12} md={12} lg={12} display={!ismenu ? "block" : "none"} width="100%">
          <Divider></Divider>
        </Grid>
        {ismenu || filter === "Kaikki Tuotteet"
          ? get_cards(data)
          : get_cards(data.filter((el) => el.type === filter))}
      </Grid>
    </Box>
  );
});

export default Pcards;
